import AppController from './AppController';
import ContainableMixin from './mixins/ContainableMixin';
import HiddenCollapsedMixin from './mixins/HiddenCollapsedMixin';
import mixin from '../privates/utils/mixin';

/* DISABLING JSDOC FOR THIS CLASS UNTIL FURTHER NOTICE:
 * @class AppWidget
 * @summary Provides functionality for the Wix Application Controller.
 * @mixes $w.Node
 * @mixes $w.AppController
 * @mixes $w.ContainableMixin
 * @memberof $w
 * @tagname AppWidget
 * @viewername platform.components.AppWidget
 */
class AppWidget extends AppController {}

mixin(AppWidget.prototype, ContainableMixin.prototype);
mixin(AppWidget.prototype, HiddenCollapsedMixin.prototype);


export default AppWidget;
